import types from 'constants/SalaryConstants';
import Immutable from 'immutable';

const initialState = Immutable.fromJS({
  adjustmentTypeList: []
});

export default function(state = initialState, action) {
	switch (action.type) {
		case types.REFRESH_ADJUSTMENT_TYPE_LIST:
      return state.set('adjustmentTypeList', Immutable.fromJS(action.typeList))

    case types.UPDATE_ADJUSTMENT_TYPE_NAME:
      return state.setIn(['adjustmentTypeList', state.get('adjustmentTypeList').findIndex((type) => type.get('id') === action.id), 'name'],
        action.name
      )

    case types.DELETE_ADJUSTMENT_TYPE:
      return state.deleteIn(['adjustmentTypeList', state.get('adjustmentTypeList').findIndex((type) => type.get('id') === action.id)])

    case types.ADD_ADJUSTMENT_TYPE:
      return state.updateIn(['adjustmentTypeList'], list => list.push(Immutable.fromJS({
        id: action.id,
        name: action.name
      })))

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/Salary.js